import { chain } from 'lodash';
import type * as XLSX from 'xlsx';

export class XlsxHelper {
  public static setAutoWidth(worksheet: XLSX.WorkSheet, data: any[][]): void {
    worksheet['!cols'] = data[0].map((_, columnIndex) =>
      chain(data)
        .map((row) => row[columnIndex])
        .map((cell): number => cell?.toString()?.length ?? 10)
        .max()
        .thru((maxWidth): XLSX.ColInfo => ({ wch: maxWidth }))
        .value(),
    );
  }

  public static setHeaderMerges(
    worksheet: XLSX.WorkSheet,
    header: any[],
  ): void {
    worksheet['!merges'] = chain(header)
      .map((_, index) => index)
      .filter((index) => header[index] != null && header[index + 1] === null)
      .map((startIndex) => {
        const endIndex = chain(header)
          .slice(startIndex + 1)
          .findIndex((value) => value !== null)
          .thru((offset) =>
            offset === -1 ? header.length - 1 : startIndex + offset,
          )
          .value();
        return { startIndex, endIndex };
      })
      .map(({ startIndex, endIndex }): XLSX.Range => ({
        s: { r: 0, c: startIndex },
        e: { r: 0, c: endIndex },
      }))
      .value();
  }
}
